
export const TILE_VIEW = "tile" as const;
export const RAIL_VIEW = "rail" as const;

export type ViewType = typeof TILE_VIEW | typeof RAIL_VIEW;